var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodDonation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 30,
    viewBox: "0 0 19 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "oq0n86o7ia",
    d: "M0 0.132L18.078 0.132 18.078 28.8 0 28.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .768)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zzv1lswzlb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oq0n86o7ia"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M16.563 2.73h-4.951c0-1.435-1.152-2.598-2.573-2.598-1.42 0-2.573 1.163-2.573 2.597h-4.95C.677 2.73 0 3.414 0 4.26v20.755c0 .846.678 1.531 1.515 1.531h2.792l1.353 1.36c.57.573 1.342.895 2.146.895h2.466c.804 0 1.575-.322 2.146-.895l1.353-1.36h2.792c.837 0 1.515-.685 1.515-1.53V4.258c0-.845-.678-1.53-1.515-1.53m-7.524.817c-.447 0-.809-.366-.809-.817 0-.45.362-.816.81-.816.446 0 .808.366.808.816 0 .451-.362.817-.809.817",
    mask: "url(#zzv1lswzlb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4333F",
    d: "M8.963 11.03c-5.348-.934-7.527 0-7.527 0v.605h.611c.171 0 .31.14.31.314 0 .172-.139.313-.31.313h-.61v.911h.61c.171 0 .31.14.31.314 0 .172-.139.313-.31.313h-.61v.912H3.19c.171 0 .31.14.31.313s-.139.313-.31.313H1.44v.913h.608c.171 0 .31.14.31.313s-.139.313-.31.313h-.608v.913h.608c.171 0 .31.14.31.312 0 .174-.139.313-.31.313H1.44v.913h1.75c.17 0 .31.14.31.313s-.14.313-.31.313H1.44v.912h.606c.171 0 .31.14.31.313s-.139.313-.31.313h-.605v.913h.605c.171 0 .31.14.31.313s-.139.312-.31.312h-.604v.913H3.19c.171 0 .31.14.31.313s-.139.313-.31.313H1.444v.238c0 .545.438.988.98.988h13.088c.54 0 .98-.443.98-.989V11.031s-2.18.934-7.529 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDE3E3",
    d: "M10.108 7.515h-.656v-.612c0-.213-.185-.387-.414-.387-.228 0-.413.174-.413.387v.612H7.97c-.229.001-.413.174-.413.387 0 .213.185.387.414.387h.654l.001.612c0 .213.186.386.413.386.229 0 .414-.173.414-.386v-.613h.655c.228 0 .414-.173.414-.387 0-.213-.186-.386-.414-.386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodDonation);
export default __webpack_public_path__ + "static/media/bloodDonation.56287c28110c0a876d2ac2adfca80cb1.svg";
export { ForwardRef as ReactComponent };